import { providerConfigSchema } from '../schema/ProviderConfig.ts';
import { validateData } from '../utils/utils.ts';
import { api } from './client.ts';
import { getConfigurationUrl } from './constants.ts';

export async function getConfiguration(
  territorySlug: string,
  vehicleId: number | undefined,
  signal?: AbortSignal,
) {
  if (vehicleId) {
    const { data } = await api.get(getConfigurationUrl(territorySlug, vehicleId), { signal });
    return validateData(providerConfigSchema, data, 'Provider config');
  }
}
